import { FC } from 'react'
import { Button } from 'featureSliced/entities/Button'
import { useTranslations } from 'featureSliced/shared/hooks/useTranslations'
import { Products } from 'components/Products'
import { useOpenProduct } from '../..'

import { ItemsContainer } from './styled'
import { StickyCtaBar } from '../../ComonProduct/styled'
import { IProduct } from 'featureSliced/shared/store/reducers/CategoriesReducer/types'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'
import { ProductTemplateIdType } from 'featureSliced/shared/store/reducers/QRMenuBucketReducer/types'

type AddSubTemplateProductProduct = {
  products: IProduct[]
  productTemplateId: ProductTemplateIdType
  closeModal: () => void
}

export const AddSubTemplateProduct: FC<AddSubTemplateProductProduct> = ({
  products,
  productTemplateId,
  closeModal,
}) => {
  // Hooks
  const t = useTranslations()
  const openProductModal = useOpenProduct()

  // Store
  const bucketProducts = useMySelector((state) => state.bucket.products)

  // Functions
  const addProduct = (product: IProduct) => {
    openProductModal(product, productTemplateId)
  }

  const getAmount = (product: IProduct) => {
    return (
      bucketProducts?.find((bProduct) => bProduct?.productId === product.id)
        ?.count || 0
    )
  }

  return (
    <>
      <ItemsContainer>
        <Products
          products={products}
          onProductClick={addProduct}
          getAmount={getAmount}
        />
      </ItemsContainer>
      <StickyCtaBar>
        <Button width="100%" buttonType="common" onClick={closeModal}>
          {t('buttons.ok')}
        </Button>
      </StickyCtaBar>
    </>
  )
}
